import { PanelTypes } from "@flightpath/coreui/dist/ui/Panel";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { Button } from "../../../../components/ui/Button";
import { Panel } from "../../../../components/ui/Panel";
import { SearchButton } from "../../../../components/ui/SearchButton";
import { RichTextEditor } from "../../../../components/ui/_forms/RichTextEditor";
import { ActivityCard } from "../../../../components/widgets/activityCard/ActivityCard_view";
import { CanEdit } from "../../../../contexts/permissions/PermissionHelpers";
import { useCanEditField, useCanViewField } from "../../../../contexts/permissions/PermissionHooks";
import { PermissionFields } from "../../../../contexts/permissions/PermissionsTypes";
import { useIsTestUser, useUserId } from "../../../../core/auth/authorise";
import I18n from "../../../../core/localization/I18n";
import { useCurrentOrganisationId } from "../../../../services/local/organisationContext/OrganisationContextModel";
import { CommentListViewModel } from "./CommentListView_model";
export interface CommentListVewProps {
  model: CommentListViewModel;
  field: PermissionFields;
}

const CommentListView: React.FunctionComponent<CommentListVewProps> = observer(props => {
  const flightPathUserId = useUserId();
  const { model } = props;
  const organisationId = useCurrentOrganisationId();
  const canEditField =
    props.field === PermissionFields.PROCESSES || useCanEditField(props.field, organisationId, model.projectId);
  const canViewField =
    props.field === PermissionFields.PROCESSES || useCanViewField(props.field, organisationId, model.projectId);
  const isTestUser = useIsTestUser();

  useEffect(() => {
    model.onMount();

    return model.onUnmount;
  }, [model]);

  return (
    <div className="comment-list-view container-fluid pt-2">
      <CanEdit field={props.field} projectId={model.projectId}>
        {model.config.description && (
          <div className="row mb-3 mt-4">
            <div className="col mx-0 px-0">{model.config.description}</div>
          </div>
        )}
        <div className="row mb-4">
          <div className="col mx-0 px-0">
            {isTestUser ? (
              <input
                id="CommentInput"
                value={model.commentInput}
                onChange={e => model.handleInputChange(e.currentTarget.value)}
              />
            ) : (
              <RichTextEditor
                placeholderText={model.config.placeholderText}
                value={model.commentInput}
                onChange={model.handleInputChange}
              />
            )}
            <div className="d-flex justify-content-end mt-2">
              <Button
                id="AddCommentButton"
                title={!model.commentInput ? I18n.t("phrases.typeSomething") : null}
                onClick={model.createComment}
              >
                {I18n.t("phrases.addNote")}
              </Button>
            </div>
          </div>
        </div>
        <hr />
      </CanEdit>

      <div className="row mb-3 mt-5">
        <div className="col mx-0 px-0">
          <SearchButton
            className="float-right"
            onChange={e => model.setSearchInput(e.currentTarget.value)}
            value={model.searchInput}
            onClose={model.resetSearchInput}
          />
        </div>
      </div>

      <div className="row pb-6" id="CommentArea">
        <div className="col mx-0 px-0">
          {model.isLoadingComments ? (
            <div>{I18n.t("phrases.loadingComments")}</div>
          ) : model.errorMessage ? (
            <div>{model.errorMessage}</div>
          ) : model.comments.length ? (
            model.filteredComments.length ? (
              model.filteredComments.map((comment, i) => {
                let actions = flightPathUserId === comment.ownerId ? model.activityCardActions : null;
                actions = canViewField ? actions : [];
                return (
                  <div className="mb-2" key={comment.id}>
                    <ActivityCard onSave={model.updateComment} comment={comment} actions={actions} />
                  </div>
                );
              })
            ) : (
              <Panel.Panel hasBorderRadius={true} type={PanelTypes.OUTLINES} className="py-2 text-center">
                <div>{I18n.t("phrases.noResultsFound")}</div>
              </Panel.Panel>
            )
          ) : (
            <Panel.Panel hasBorderRadius={true} type={PanelTypes.OUTLINES} className="py-2 text-center">
              {canEditField ? (
                <div>{I18n.t("phrases.noComments")}</div>
              ) : (
                <div>{I18n.t("phrases.noCommentsCantEdit")}</div>
              )}
            </Panel.Panel>
          )}
        </div>
      </div>
    </div>
  );
});

export { CommentListView };
